import { PROTOCOLS_ACTION_TYPES } from '../../actions/protocols/protocols_action';
import { startOfYear, endOfYear } from 'date-fns';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {
        showFilters: false,
        customer: null,
        startDate: startOfYear(new Date()),
        endDate: endOfYear(new Date())
    }
};

export const protocols = (state = initialState, action) => {
    switch (action.type) {
        case PROTOCOLS_ACTION_TYPES.GET_PROTOCOLS_SUCCESS:
            return { ...state, collection: action.payload };
        case PROTOCOLS_ACTION_TYPES.UPDATE_PROTOCOLS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
